import { Globe, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGS, useLang } from "@/i18n";

const NAMES = { es: "Español", en: "English", pt: "Português", fr: "Français", it: "Italiano" };

export const LangSwitcher = ({ dark = false }) => {
  const { lang, setLang } = useLang();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid="lang-switcher"
        className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-2 text-[12px] font-bold uppercase tracking-[0.12em] transition-colors ${dark ? "border-paper/30 text-paper hover:border-banana hover:text-banana" : "border-jungle/20 text-jungle hover:border-mango hover:text-mango"}`}
      >
        <Globe size={14} />
        {lang}
        <ChevronDown size={12} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-2xl bg-paper border-jungle/15 min-w-[150px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`lang-option-${l}`}
            onClick={() => setLang(l)}
            className={`cursor-pointer rounded-xl text-sm ${l === lang ? "text-mango font-bold" : "text-jungle"}`}
          >
            <span className="font-mono-ed text-xs uppercase w-6">{l}</span> {NAMES[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
